__turbopack_context__.v({
  "custom-backdrop": "deviceFaultyFormModal-module-scss-module__5vbKMq__custom-backdrop",
  "custom-modal": "deviceFaultyFormModal-module-scss-module__5vbKMq__custom-modal",
  "modal-header": "deviceFaultyFormModal-module-scss-module__5vbKMq__modal-header",
  "modal-subtitle": "deviceFaultyFormModal-module-scss-module__5vbKMq__modal-subtitle",
  "modal-title": "deviceFaultyFormModal-module-scss-module__5vbKMq__modal-title",
});
